import { defineStore } from "pinia";
import _ from 'lodash';

import type { IProgramTypeVm } from "@/types";

export const useProgramTypeStore = defineStore({
    id: "useProgramTypeStore",
    state: () => ({
        programTypes: [] as Array<IProgramTypeVm>,
        isLoadingProgramTypes: false
    }),
    getters: {},
    actions: {
        async loadProgramTypes() {
            if(this.programTypes && this.programTypes.length > 0) return

            if(this.isLoadingProgramTypes) {
                return;    
            }

            this.isLoadingProgramTypes = true;
            try {
                var url = `/api/Participation/GetProgramTypes`;
                const response = await this.axiosFactory.withoutToken().get(url);
                this.programTypes = response.data.data;
            } catch (error: any) {
                console.log(error.response)
            } finally {
                this.isLoadingProgramTypes = false;
            }
        },
    }
});
